module.exports = __webpack_public_path__ + "media/images/lp_mb-bg2-cf18c320c27d602497ed12025326571f.png";